export default "/images/vendor/flag-icon-css/flags/1x1/cm.svg?b99d016f9deaed66ab09887011b9f849";